import { BaseModel, fillOwnProperties } from '~/shared/model'
import type { UnknownObject } from '~/shared/interfaces'
import { isUnknownObject } from '~/shared/utils/guards'
import { uuid } from '~/shared/utils/helpers'

/**
 * Полное описание полей содержится на странице
 * https://dadata.ru/api/suggest/address/
 *
 * Поля вложенного объекта data читаются через геттеры: DaData возвращает там
 * несколько десятков ключей, и объявлять их все как свойства модели незачем.
 */
export default class Address extends BaseModel {
  static override constructorName = 'Address'

  readonly id: string = uuid()
  value: string = ''
  'unrestricted_value': string = ''

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['id'])
    }
  }

  get suggestionData(): UnknownObject {
    return isUnknownObject(this.rawData.data) ? this.rawData.data : {}
  }

  get fiasId(): string {
    const { fias_id: fiasId } = this.suggestionData
    return fiasId ? String(fiasId) : ''
  }

  get locality(): string {
    const { city_with_type: city, settlement_with_type: settlement } = this.suggestionData
    return String(city || settlement || '')
  }

  get postalCode(): string {
    const { postal_code: postalCode } = this.suggestionData
    return postalCode ? String(postalCode) : ''
  }
}
